<script setup lang="ts">
import { Heading } from "~/components/clarity-ui/Heading";
import useCommonLabels from "~/composables/useCommonLabels";
import SvgIcon from "~/templates/elements/SvgIcon.vue";
import LevelTwoList from "~/templates/partials/navigation/LevelTwoList.vue";
import LevelTwoProductOverview from "~/templates/partials/navigation/LevelTwoProductOverview.vue";
import { mapNodes } from "~/utils/helper/magnolia";

export interface LevelTwoProps {
  level: object;
  isActive: boolean;
}

const { level } = defineProps<LevelTwoProps>();
const emit = defineEmits(["level-close"]);

const { isMobileMode } = useMainNavigationState();
const { getLabelByPath } = useCommonLabels();

const type = computed(() => {
  const nodes = mapNodes(level);
  return nodes.find((subNode) => subNode["@nodeType"] === "nav:productlink") ? "product" : "list";
});
const closeMenuAriaLabel = computed(() =>
  getLabelByPath("BWF/shared/hamburgerMenuAriaLabelOpened"),
);
</script>

<template>
  <div
    class="max-xl:p-0 xl:pt-4"
    :class="{
      '-translate-y-4 opacity-0 motion-safe:transition-all motion-safe:duration-300': !isMobileMode,
      'translate-y-0 opacity-100 delay-300': !isMobileMode && isActive,
    }"
  >
    <template v-if="!isMobileMode">
      <div class="mb-4 flex items-center">
        <Heading size="medium" tag="div">{{ level.title }}</Heading>
        <button
          class="relative -mr-2 ml-auto h-11 w-11 rounded-md p-2 hover:text-deep-blue"
          :aria-label="closeMenuAriaLabel"
          @click="emit('level-close')"
        >
          <SvgIcon
            class="absolute left-[calc(50%-12px)] top-[calc(50%-12px)] h-6 w-6"
            name="icon-menu-close"
          />
        </button>
      </div>
    </template>
    <LevelTwoList v-if="type === 'list'" :level="level" />
    <LevelTwoProductOverview v-else-if="type === 'product'" :level="level" />
  </div>
</template>
